firebird.controller('virtualAssistantLanguageSelectionCtrl', [
    '$rootScope',
    '$scope',
    'logService',
    'localizationService',
    function ($rootScope, $scope, logService, localizationService) {
        var self = this;

        self.closeModal = closeModal;
        self.mapLanguageCodeToSymblLanguageCode = mapLanguageCodeToSymblLanguageCode;
        self.setLanguage = setLanguage;
        self.getLanguage = getLanguage;
        self.startTranscription = startTranscription;
        self.getShouldBePlacedOnTop = getShouldBePlacedOnTop;
        self.getAvailableLanguages = getAvailableLanguages;
        self.isLanguageSupportedBySymbl = isLanguageSupportedBySymbl;

        //commented out languages are supported by symbl, but no punctuation support.
        //leaving out for now
        self.symblSupportedLanguage = [
            'en-US',
            'en-AU',
            'en-GB',
            'fr-CA',
            'fr-FR',
            'de-DE',
            'it-IT',
            'nl-NL',
            'es-US',
            'ja-JP'
        ];
        self.modalState = 'closed';
        self.model = self.getAvailableLanguages();
        self.selectedLanguage = self.mapLanguageCodeToSymblLanguageCode(localizationService.getLocalization());

        $scope.$on('show-modal', onShowModal);
        $scope.$on('hide-modal', onHideModal);

        function getAvailableLanguages() {
            var langs = [];
            self.symblSupportedLanguage.forEach(function (lang) {
                var obj = {};
                obj.code = lang;
                obj.text = localizationService.translate('VIRTUAL_ASSISTANT.LANGUAGE_SELECTION.' + lang.toUpperCase());
                obj.placedOnTop = self.getShouldBePlacedOnTop(lang);
                langs.push(obj);
            });
            return langs;
        }

        function getShouldBePlacedOnTop(code) {
            var mappedCode = self.mapLanguageCodeToSymblLanguageCode(localizationService.getLocalization());
            return mappedCode.toLowerCase() === code.toLowerCase() ? 1 : 0;
        }

        function isLanguageSupportedBySymbl(languageCode) {
            var result;
            result = self.symblSupportedLanguage.find(function (code) {
                return code.toLowerCase() == languageCode.toLowerCase();
            });
            return !!result;
        }

        function mapLanguageCodeToSymblLanguageCode(languageCode) {
            //this is for special cases like es-419 where we want to use what symbl has
            var symblLanguageCode = '';
            switch (languageCode.toLowerCase()) {
                case 'es-419':
                    symblLanguageCode = 'es-US';
                    break;
                default:
                    symblLanguageCode = languageCode;
            }

            return symblLanguageCode;
        }

        function setLanguage(code) {
            self.selectedLanguage = code;
        }

        function getLanguage() {
            return self.selectedLanguage;
        }

        function onShowModal(e, modalName, tabName) {
            if (modalName === 'virtualAssistantLanguageSelection') {
                self.modalState = 'open';
                digest();
            }
        }

        //Closed via broadcasted event
        function onHideModal(e, modalName) {
            if (modalName.indexOf('virtualAssistantLanguageSelection') !== -1) {
                self.closeModal();
            }
        }

        //Closed via Cancel or Save buttons
        function closeModal() {
            self.modalState = 'closed';
            digest();
        }

        function startTranscription() {
            //if there's no language selected or the language is not supported by symbl, use us english as default
            if (!self.selectedLanguage || self.isLanguageSupportedBySymbl(self.selectedLanguage) == false) {
                self.selectedLanguage = 'en-US';
            }
            $rootScope.$broadcast('va-language-set', { languageCode: self.selectedLanguage });
            self.closeModal();
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
